<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3435_53410)">
      <mask
        id="mask0_3435_53410"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <path d="M24 0.5H0V24.5H24V0.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3435_53410)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.8125 0.5H21.1875C22.7408 0.5 24 1.7592 24 3.3125V21.6875C24 23.2408 22.7408 24.5 21.1875 24.5H2.8125C1.2592 24.5 0 23.2408 0 21.6875V3.3125C0 1.7592 1.2592 0.5 2.8125 0.5ZM19.161 5.1875H16.68L12.5917 9.86075L9.05698 5.1875H3.9375L10.0545 13.1863L4.257 19.8125H6.73948L11.214 14.6998L15.1245 19.8125H20.1172L13.7407 11.3825L19.161 5.1875ZM17.184 18.3275H15.8092L6.83473 6.5945H8.30998L17.184 18.3275Z"
          :fill="color"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3435_53410">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#98A2B3",
  },
});
</script>
